/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { Text } from '../../../atoms/Text/Text';
import './PlanProgressRendererStyles.scss';
const baseClass = 'qmb-ui-plan-progress-renderer';
function statusIcon(status) {
    switch (status) {
        case 'success':
            return React.createElement("i", { className: "fa-light fa-circle-check", style: { color: 'var(--green-01, #16a34a)' } });
        case 'error':
            return React.createElement("i", { className: "fa-light fa-circle-xmark", style: { color: 'var(--red-01, #dc2626)' } });
        case 'skipped':
            return React.createElement("i", { className: "fa-light fa-circle-minus", style: { color: 'var(--gray-03, #9ca3af)' } });
        case 'executing':
        default:
            return React.createElement("i", { className: "fa-light fa-spinner-third fa-spin" });
    }
}
export function PlanProgressRenderer({ block }) {
    const progress = block;
    return (React.createElement("div", { className: baseClass },
        React.createElement("div", { className: `${baseClass}__header` },
            statusIcon(progress.step_status),
            React.createElement(Text, { variant: "body" },
                "Step ",
                progress.step_index + 1,
                " of ",
                progress.total_steps)),
        React.createElement(Text, { variant: "body", className: `${baseClass}__summary` }, progress.step_summary),
        progress.error_message && (React.createElement(Text, { variant: "body", className: `${baseClass}__error` }, progress.error_message))));
}
